import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

import DataPrivDisclaimer from '../../DataPrivDisclaimer'

import mapIcon from '../../../images/icons/map_lg_gold.png'
import persIcon from '../../../images/icons/person_double_lg_gold.png'
import locIcon from '../../../images/icons/bed.svg'
import creditIcon from '../../../images/icons/credits.png'

import { Center, GoldHeading, Black, LogeButtonSlim, Icon, SpinnerWrapper } from '../../GeneralStyle'
import { DoubleBounce } from 'better-react-spinkit'

import ReactGA from "react-ga";

@inject('bookingStore')

@observer
class ConfirmBooking extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: false,
      loading: false,
    };
    this.confirmBooking = this.confirmBooking.bind(this)
  }

  confirmBooking(bookingDate, golfCourse, slots ) {

    this.setState({
      loading: true,
      disabled: true
    })

    this.props.bookingStore.createBooking(
      bookingDate,
      golfCourse.objectId,
      slots
    );
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Confirm - Booking'
    });
  }

  render() {
    const {
      bookingDate,
      golfCourse,
      slots,
      setScreenNumber,
      screenNumber,
      isInvite,
      includeMyself,
      guests,
      isBookingModalError
    } = this.props.bookingStore

    return (
      <div style={{ paddingTop: 35, paddingBottom: 35 }}>
        <Row>
          <Col sm={2} md={2} lg={2}>
            <Center><Icon size={45} margin={15} icon={persIcon} float={"right"} /></Center>
          </Col>
          <Col sm={10} md={10} lg={10}>
            <GoldHeading>WER?</GoldHeading>

            {isInvite && includeMyself &&
              <div>
                <Black fontWeight={"bold"} display={"inline"}>Sie persönlich</Black>
                {guests.map((guest, key) => {
                  return (
                    <div style={{ display: "inline" }} key={key}>
                      <Black display={"inline"}> &amp; </Black>
                      <Black fontWeight={"bold"} display={"inline"}>{guest.firstname} {guest.lastname}</Black>
                    </div>
                  )
                })}
              </div>}

            {isInvite && !includeMyself &&
              <div>
                {guests.map((guest, key) => {
                  return (
                    <div style={{ display: "inline" }} key={key}>
                      <Black fontWeight={"bold"} display={"inline"}>{guest.firstname} {guest.lastname}</Black>
                      {(key < (guests.length - 1)) && <Black display={"inline"}> &amp; </Black>}
                    </div>
                  )
                })}
              </div>}

            {!isInvite && slots === 1 &&
              <Black fontWeight="bold">Eine Person</Black>}

            {!isInvite && slots > 1 &&
              <Black fontWeight="bold">{slots} Personen</Black>}
          </Col>
        </Row>
        <Row>
          <Col sm={2} md={2} lg={2}>
            <Center><Icon size={45} margin={15} float={"right"} /></Center>
          </Col>
          <Col sm={10} md={10} lg={10}>
            <GoldHeading>WANN?</GoldHeading>
            <Black>am {moment(bookingDate).locale("de").format('dddd[, den] Do MMMM YYYY')}</Black>
          </Col>
        </Row>
        <Row>
          <Col sm={2} md={2} lg={2}>
            <Center><Icon size={45} margin={15} icon={mapIcon} float={"right"} /></Center>
          </Col>
          <Col sm={10} md={10} lg={10}>
            <GoldHeading>WO?</GoldHeading>
            <Black>{golfCourse.courseName}</Black>
          </Col>
        </Row>

        { golfCourse.hotels.length > 0 &&
          <Row>
            <Col sm={2} md={2} lg={2}>
              <Center><Icon size={45} margin={15} icon={locIcon} float={"right"} /></Center>
            </Col>
            <Col sm={10} md={10} lg={10}>
              <GoldHeading>HOTEL?</GoldHeading>
              {
                golfCourse.hotels.map(hotel =>
                  <div>
                    <Black style={{display: "inline-block"}}>{ hotel.name } -&nbsp;</Black>
                    <Black style={{display: "inline-block"}}><span onClick={() => {window.open("/internal/hotels/" + hotel.id, "_blank") }} style={{textDecoration: "underline", cursor: "pointer"}} >anzeigen</span></Black>
                  </div>
                )
              }
            </Col>
          </Row>
        }
        <Row>
          <Col sm={2} md={2} lg={2}>
            <Center><Icon size={45} margin={15} icon={creditIcon}  float={"right"} /></Center>
          </Col>
          <Col sm={10} md={10} lg={10}>
            <GoldHeading>Credits</GoldHeading>
            <Black>{ golfCourse.price * slots}</Black>
          </Col>
        </Row>

        <Center marginTop={30} marginBottom={30}>
          {!isBookingModalError?
            this.state.loading ?
              <div>
                <SpinnerWrapper>
                  <DoubleBounce color={"#DAB777"} size={60}/>
                </SpinnerWrapper>
              </div>
            :
            <div>
              <div style={{ maxWidth: 400, paddingBottom: 25, textAlign: "center", margin: 'auto' }}><DataPrivDisclaimer /></div>
              <LogeButtonSlim
                hoverFontColor={"white"}
                onClick={() => setScreenNumber(screenNumber - 1)}>
                Zurück</LogeButtonSlim>

              <LogeButtonSlim
                hoverFontColor={"white"}
                onClick={() => {
                  this.state.disabled ? null : this.confirmBooking(bookingDate, golfCourse, slots)
                }}>
                Bestätigen</LogeButtonSlim>
            </div>
            :
            <div>
              <DataPrivDisclaimer />
              <LogeButtonSlim
                hoverFontColor={"white"}
                onClick={() => {
                  this.props.closeModal()
                }}>
                Zurück</LogeButtonSlim>

              <LogeButtonSlim
                disabled
                hoverFontColor={"white"}
                color={"#444"}
                fontColor={"#444"}>
                Bestätigen</LogeButtonSlim>
            </div>
          }

        </Center>
      </div>
    );
  }
}

ConfirmBooking.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
};

export default ConfirmBooking;



// WEBPACK FOOTER //
// /src/components/internal/BookingModal/ConfirmBooking.js